import { useCallback } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { apiClient } from '../../utils/api';

export const useNotionDataApi = () => {
  const { user } = useAuth();

  const getNotionData = useCallback(async (databaseId) => {
    const headers = {};
    
    // Add telegram ID header if user is authenticated
    if (user?.telegramId) {
      headers['x-telegram-id'] = user.telegramId.toString();
    }

    const response = await apiClient.get('/api/notion-data', {
      params: { databaseId },
      headers
    });
    return response.data;
  }, [user]);

  return {
    getNotionData
  };
};

